import type { SafeAreaInsets } from "@/platform/bridge/types"

export const APP_MODE_ATTRIBUTE = "data-app-mode"

export const SAFE_AREA_VARIABLES: Readonly<Record<keyof SafeAreaInsets, string>> = {
  top: "--nelo-safe-top",
  right: "--nelo-safe-right",
  bottom: "--nelo-safe-bottom",
  left: "--nelo-safe-left",
}

export const isAppMode = (): boolean => typeof document !== "undefined" && document.documentElement.hasAttribute(APP_MODE_ATTRIBUTE)

export const readSafeArea = (data: Record<string, unknown>): SafeAreaInsets | undefined => {
  const candidate = data.safeArea

  if (typeof candidate !== "object" || candidate === null) return undefined

  const { top, right, bottom, left } = candidate as Record<string, unknown>

  if (typeof top !== "number" || typeof right !== "number" || typeof bottom !== "number" || typeof left !== "number") return undefined

  return { top, right, bottom, left }
}
